import { render, staticRenderFns } from "./adminCustomerIds.vue?vue&type=template&id=03134ce2&"
import script from "./adminCustomerIds.vue?vue&type=script&lang=ts&"
export * from "./adminCustomerIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports